import { FormikErrors, FormikValues } from 'formik';
import gtm from './gtm';

export default function trackValidationError<Values extends FormikValues>(
  widget: string,
  /** The name of the current form or step */
  form: string,
  errors: FormikErrors<Values>,
) {
  const errorsAsString = Object.entries(errors).map(([key, value]) => {
    return `${key}=${String(value)}`;
  }).join(',');

  gtm.trackUserEvent(widget, `Validation error - ${form}`, errorsAsString);
}
